<template>
  <div class="getCashConfirm">
    <job-header-simple header_title="提现"></job-header-simple>
    <p class="info">为了您账号的资金安全，需要向您绑定的手机发送验证码，请注意短信接收。</p>
    <div class="formSection">
      <van-field v-model="registerForm.mobile" clearable readonly>
        <template slot="button">
          <van-button @click="handleCode" size="small" :type="isOn?'default':'primary'">
            <van-count-down ref="countDown" :auto-start="false" @finish="countFinished" :time="time" format="ss" v-show="isOn" />
            <template v-if="isOn">后重新获取</template>
            <template v-else>获取验证码</template>
          </van-button>
        </template>
      </van-field>
      <van-field v-model="registerForm.code" clearable placeholder="请填写验证码" />
      <div class="btn">
        <van-button type="info" block round @click="onClickButtonSubmit" :loading="isLoading" loading-text="验证信息中...">提交验证</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Field, Toast, CountDown, Notify } from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import { checkAndCash ,checkCode ,sendUserVerifySms,getEmployeeAccount} from "@/api/emolument/request";
import api from "@/api/list";
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [CountDown.name]: CountDown,
    [Notify.name]: Notify,
    jobHeaderSimple,
  },
  data() {
    return {
      registerForm: {
        mobile: "",
        code: "",
        type: 1,
        token:"",
        account:this.$route.params.account,
        amount:this.$route.params.amount,
        ocompanyId:this.$route.params.ocompanyId,
      },
      isLoading: false,
      time: 60 * 1000, //5秒
      isOn: false,
      token: null,
      amount:this.$route.params.amount,
      ocompanyId:this.$route.params.ocompanyId,
      account:this.$route.params.account,
      ocompanyName:this.$route.params.ocompanyName,
    };
  },
  created() {
    this.initEmployeeAccount();
  },
  methods: {
    // 获取支付宝信息
    initEmployeeAccount(){
      getEmployeeAccount().then((res) => {
        if (res.data.status == "200" && res.data.data){
           this.registerForm.mobile = res.data.data.mobile;

        }
      });
    },

    onClickButtonSubmit() {
      // for (let key in this.registerForm) {
      //   this.registerForm[key] = this.registerForm[key].trim();
      // }
      if (this.registerForm.code == "") {
        this.$toast("验证码不能为空");
        return false;
      }
      this.isLoading = true;
      //this.$router.push({path:"/getCashResult"});
      //校验手机验证码
      checkCode(this.registerForm).then((res) => {
        if (res.data.status == "200" ){
          checkAndCash(this.registerForm).then((res) => {
            if (res.data.status == "200" ){
              //成功校验
              this.$router.push({name:"getCashResult",params: {status:1,
                ocompanyId:this.ocompanyId,amount:this.amount,
                ocompanyName:this.ocompanyName,account:this.account
              }});
            }else{
              //失败校验
              this.$router.push({name:"getCashResult",params: {status:0,
                  ocompanyId:this.ocompanyId,amount:this.amount,reason:res.data.message,
                  ocompanyName:this.ocompanyName,account:this.account
                }
              });
            }
          })
        }else{
          this.isLoading = false;
          this.$toast(res.data.message);
          return false;
        }
      });
    },
    handleCode() {
      if (this.isOn == false) {
        sendUserVerifySms(this.registerForm.mobile)
          .then((res) => {
            if (res.data.status == "200") {
              this.registerForm.token = res.data.data;
              this.isOn = true;
              this.$refs.countDown.start();
            } else {
              this.$toast(res.data.message);
            }
          })
          .catch((error) => {
            this.$toast(error.response.data.message);
            this.loading = false;
          });
      }
    },
    countFinished() {
      this.isOn = false;
      this.$refs.countDown.reset();
    },
  },
};
</script>
<style lang="less" scoped>
.getCashConfirm {
  padding: 0 8px 8px;

  .info {
    font-size: 0.32rem;
    color: #a7a7a7;
    padding: 0.2667rem;
  }

  .formSection {
    border-radius: 8px;
    overflow: hidden;
    background: #fff;
    padding: 12px 0;

    .van-count-down {
      display: inline-block;
    }

    .btn {
      padding: 20px;
    }
  }
}
</style>